/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { useTwilioConversationBySid, useWindowSize } from '@brands/hooks';
import { useConversationStatistics } from '../../hooks/useConversationStatistics';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { getConversation } from '@brands/services/communication/getConversation';
import { IGMConversation } from '@brands/services/communication/types/IGMConversation';
import { IGMConversationParticipant } from '@brands/services/communication/types/IGMConversationParticipant';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { getButtonHoverColor } from '@brands/Utils/getPrimaryColor';
import { Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { isAxiosError } from 'axios';

import CaseConversationList from '../../ChatWindow/ChatComponents/Patient/CaseConversationList';
import CaseMessageBody from '../../ChatWindow/ChatComponents/Patient/CaseMessageBody';
import Container from '../../Components/Container/Container';
import { Loading } from '../../Components/LoadingSpinner/Loading';
import styles from './styles.module.scss';


const CaseChatWindow = (): JSX.Element => {
  const { userInfo } = useAppSelector(selectAuth);
  const screenSize = useWindowSize();
  const [thisCaseId, setCaseId] = useState<number>();
  const [selectedConversationParticipants, setSelectedConversationParticipants] = useState<
    IGMConversationParticipant[]
  >([]);

  // Care advisors and admins were deliberately routed onto this screen rather than the
  // older staff Messages page, so every role shares this empty state. The design only
  // supplies the patient wording; staff need copy describing their own side of the
  // conversation instead of being told a care team will message them.
  const isPatient = userInfo?.role?.name === UserRoleName.Patient;
  const emptyConversationsDetail = isPatient
    ? 'Your care team will message you here once your case is active or if they need to share updates.'
    : 'Conversations appear here once a case is active or a participant sends an update.';

  const backPath = sessionStorage.getItem('lastNonMessagesPath') || '/';
  const [selectedConversationForMessageBody, setSelectedConversationForMessageBody] = useState<IGMConversation>();
  const routeConversationSid = useParams().conversationSid || null;
  const [conversationSid, setConversationSid] = useState<string | null>(routeConversationSid);
  const twilioConversation = useTwilioConversationBySid(conversationSid);
  const [readOnlyConversation, setReadOnlyConversation] = useState<IGMConversation | null>(null);
  const isMobile = screenSize.width < 970;
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [loadingScreen, setLoading] = useState(false);

  const {
    statistics: activeConversations,
    refresh: refreshActive,
    loading: loadingActive,
  } = useConversationStatistics('active');
  const {
    statistics: archivedConversations,
    refresh: refreshArchived,
    loading: loadingArchived,
  } = useConversationStatistics('archived');

  const hasActive = activeConversations.length > 0;
  const hasArchived = archivedConversations.length > 0;

  const [selectedTab, setSelectedTab] = useState<'active' | 'archived'>('active');

  const statistics = selectedTab === 'active' ? activeConversations : archivedConversations;

  useEffect(() => {
    const list = selectedTab === 'active' ? activeConversations : archivedConversations;

    // only set if nothing selected yet
    if (list.length > 0 && !conversationSid && !isMobile) {
      setConversationSid(list[0].conversation_sid);
      setCaseId(list[0].case_id);
    }
  }, [selectedTab, activeConversations, archivedConversations, conversationSid]);

  const refresh = selectedTab === 'active' ? refreshActive : refreshArchived;

  const loading = selectedTab === 'active' ? loadingActive : loadingArchived;

  const roleNavigate = useRoleNavigate();

  const getReadOnlyConversation = (): Promise<IGMConversation | null> => {
    if (conversationSid) return getConversation(conversationSid, true, userInfo?.role?.name);
    return Promise.resolve(null);
  };
  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: 'active' | 'archived' | null): void => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };

  const updateUnreadNotification = (): void => {
    // if (
    //   thisCase?.patient_care_advisor_conversation_stats &&
    //   thisCase?.patient_care_advisor_conversation_stats?.length > 0 &&
    //   thisCase?.patient_care_advisor_conversation_stats[0]?.conversation_sid === conversationSid
    // ) {
    //   setCase({
    //     ...thisCase,
    //     patient_care_advisor_conversation_stats: null,
    //   });
    // }
    // if (
    //   thisCase?.patient_provider_conversation_stats &&
    //   thisCase?.patient_provider_conversation_stats?.length > 0 &&
    //   thisCase?.patient_provider_conversation_stats[0]?.conversation_sid === conversationSid
    // ) {
    //   setCase({
    //     ...thisCase,
    //     patient_provider_conversation_stats: null,
    //   });
    // }
    // if (
    //   thisCase?.provider_care_advisor_conversation_stats &&
    //   thisCase?.provider_care_advisor_conversation_stats.length > 0 &&
    //   thisCase?.provider_care_advisor_conversation_stats[0]?.conversation_sid === conversationSid
    // ) {
    //   setCase({
    //     ...thisCase,
    //     provider_care_advisor_conversation_stats: null,
    //   });
    // }
  };

  const changeCaseUnreadIndicator = async (): Promise<void> => {
    // if (case_id) {
    //   try {
    //     const updatedCase = await getOneCase(case_id, {
    //       include_patient_care_advisor_conversation: true,
    //       include_patient_provider_conversation: true,
    //       include_provider_care_advisor_conversation: userInfo.role.name !== UserRoleName.Patient,
    //     });
    //     if (updatedCase && thisCase) {
    //       setCase({
    //         ...thisCase,
    //         patient_care_advisor_conversation_sid: updatedCase.patient_care_advisor_conversation_sid,
    //         patient_provider_conversation_sid: updatedCase.patient_provider_conversation_sid,
    //         provider_care_advisor_conversation_sid: updatedCase.provider_care_advisor_conversation_sid,
    //         patient_care_advisor_conversation_stats: updatedCase.patient_care_advisor_conversation_stats,
    //         patient_provider_conversation_stats: updatedCase.patient_provider_conversation_stats,
    //         provider_care_advisor_conversation_stats: updatedCase.provider_care_advisor_conversation_stats,
    //       });
    //     }
    //   } catch (error: unknown) {
    //     displayErrorDetails(error);
    //   }
    // }
  };

  // const onMessage = useCallback(
  //   async (message: Record<string, any>) => {
  //     if (thisCase && Number(message.case_id) === Number(thisCase.id)) {
  //       if (['case_new_message_created'].includes(message.command)) {
  //         if (thisCase && !isEqual(thisCase, defaultICaseValues)) {
  //           changeCaseUnreadIndicator();
  //         }
  //       } else if (['case_canceled', 'case_completed', 'case_updated'].includes(message.command)) {
  //         if (conversationSid) {
  //           const updatedConversation = await getReadOnlyConversation();
  //           if (updatedConversation?.state !== 'active') {
  //             refreshConversation();
  //           }
  //         }
  //       }
  //     }
  //   },
  //   [thisCase],
  // );

  // useEffect(() => {
  //   getCurrentCase(routeCaseId);
  // }, []);

  useEffect(() => {
    if (!routeConversationSid) {
      return;
    }
    setConversationSid(routeConversationSid);
  }, [routeConversationSid]);

  useEffect(() => {
    getReadOnlyConversation()
      .then((readOnly) => {
        setReadOnlyConversation(readOnly);
      })
      .catch((error) => {
        if (isAxiosError(error) && error.response?.status === 403) {
          displayErrorDetails("You don't have access to this case/conversation.");
          return;
        }
        displayErrorDetails(error);
      });
  }, [conversationSid]);

  useEffect(() => {
    const list = selectedTab === 'active' ? activeConversations : archivedConversations;

    // only set if nothing selected yet
    if (list.length > 0 && !conversationSid && !isMobile) {
      setConversationSid(list[0].conversation_sid);
      setCaseId(list[0].case_id);
    } else if (list.length === 0) {
      setConversationSid(null);
      setCaseId(undefined);
    }
  }, [selectedTab, activeConversations, archivedConversations]);

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
    >
      {!hasActive && !hasArchived ? (
        <div className={styles.noMessages}>
          <span className={styles.noMessagesHeader}>You haven’t received any messages yet.</span>
          <span className={styles.noMessagesContent}>{emptyConversationsDetail}</span>
        </div>
      ) : loading ? (
        <Loading dotted />
      ) : (
        <div className={styles.CaseChatContainer}>
          <div className={styles.CaseChatContainerDiv}>
            {(!isMobile || (isMobile && !conversationSid)) && (
              <div className={styles.CaseChatContainerLeftDiv}>
                <Button
                  type="button"
                  variant="text"
                  className={styles.backButton}
                  sx={{
                    width: 'fit-content',
                  }}
                  onClick={() => roleNavigate(backPath)}
                >
                  <MdKeyboardArrowLeft />
                  Back
                </Button>
                <div className={styles.navDiv}>
                  <span className={styles.CaseChatContainerLeftDivSpan}>Messages</span>
                  <ToggleButtonGroup
                    value={selectedTab}
                    exclusive
                    onChange={handleChange}
                    className={styles.navDivOption}
                    sx={{
                      p: '4px',
                      gap: '8px',
                      '& .MuiToggleButton-root': {
                        border: 'none',
                        borderRadius: '32px',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontFamily: 'Poppins',
                        // Both states used the button *hover* colour as their
                        // resting colour, so the two tabs were identical and
                        // neither was the design's. The design dims the tab you
                        // are not on to 70% of the product navy and shows the
                        // one you are on at full strength.
                        color: 'rgba(13, 32, 53, 0.7)',
                        fontSize: '14px',
                        px: '16px',
                        py: '6px',
                      },
                      '& .Mui-selected': {
                        backgroundColor: '#B0E7FA !important',
                        color: 'var(--color-text-primary) !important',
                      },
                    }}
                  >
                    <ToggleButton value="active">Active</ToggleButton>
                    <ToggleButton value="archived">Archived</ToggleButton>
                  </ToggleButtonGroup>
                  {statistics && statistics.length > 0 ? (
                    <CaseConversationList
                      thisCaseId={thisCaseId}
                      activeConversationSid={conversationSid}
                      setActiveConversationSid={setConversationSid}
                      conversations={statistics}
                      setCaseId={setCaseId}
                      setLoading={setLoading}
                      changeCaseUnreadIndicator={changeCaseUnreadIndicator}
                      setSelectedConversationParticipants={setSelectedConversationParticipants}
                      setSelectedConversationForMessageBody={setSelectedConversationForMessageBody}
                    />
                  ) : !hasArchived && selectedTab === 'archived' ? (
                    <div className={styles.noConversationListDiv}>
                      <span className={styles.noConversationListHeader}>
                        You don’t have any archived conversations.
                      </span>
                      <span className={styles.noConversationListTitle}>
                        Messages from closed cases will be moved here automatically.
                      </span>
                    </div>
                  ) : !hasActive && selectedTab === 'active' ? (
                    <div className={styles.noConversationListDiv}>
                      <span className={styles.noConversationListHeader}>You don’t have any active conversations.</span>
                      <span className={styles.noConversationListTitle}>{emptyConversationsDetail}</span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            )}
            {statistics === undefined ? (
              <Loading dotted />
            ) : (!isMobile || (isMobile && conversationSid)) && conversationSid ? (
              <div className={styles.CaseChatContainerRightDiv}>
                <div className={styles.CaseChatContainerRightDivContent}>
                  <CaseMessageBody
                    twilioConversation={twilioConversation}
                    readOnlyConversation={readOnlyConversation}
                    isMobile={isMobile}
                    conversationSid={conversationSid}
                    setConversationSid={setConversationSid}
                    conversations={statistics}
                    isProfileCard={false}
                    setLeaveModalOpen={setLeaveModalOpen}
                    leaveModalOpen={leaveModalOpen}
                    currentCaseId={thisCaseId}
                    updateUnreadNotification={updateUnreadNotification}
                    loading={loading || loadingScreen}
                    setLoading={setLoading}
                    selectedConversationParticipants={selectedConversationParticipants}
                    selectedConversationForMessageBody={selectedConversationForMessageBody}
                    setSelectedConversationParticipants={setSelectedConversationParticipants}
                    setSelectedConversationForMessageBody={setSelectedConversationForMessageBody}
                    refresh={refresh}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      )}
    </Container>
  );
};

export default CaseChatWindow;
